import { Link } from '@mui/material';
import { LinkProps } from 'react-router-dom';

import { usePath } from '@cast/utils';

import { Link as RouterLink } from 'components/router';
import { makeWorkloadCostMonitoringLink } from 'features/cluster/cost-report/links';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { LinkBehaviour, Typography } from '@cast/design-system';

type Props = {
  workload: string | undefined;
  namespace: string | undefined;
  workloadType: string | undefined;
  clusterId?: string;
} & Omit<Partial<LinkProps>, 'to' | 'component'>;

export const WorkloadDetailsLinkCell = ({
  workload,
  namespace,
  workloadType,
  clusterId,
  ...linkProps
}: Props) => {
  // TODO: get rid of useCluster() (temporary solution to avoid missing params errors)
  /*
    dispatchReplaceStateEvent() and CustomEvent (REPLACE_STATE_EVENT) cause missing param issues.
    CustomEvent is being sent with a delay, causing the usePath() handler to receive the old URL (window.location.pathname) when attempting to create a link and extract parameters that do not exist in buildLinkToReport()
    */
  const { cluster } = useCluster();
  const _clusterId = clusterId || cluster?.id;
  const paramsNotEmpty =
    !!workload?.length &&
    !!namespace?.length &&
    !!workloadType?.length &&
    !!_clusterId?.length;

  const link = usePath(
    () =>
      makeWorkloadCostMonitoringLink({
        workloadName: workload,
        namespace,
        workloadType,
        clusterId: _clusterId,
      }),
    { enabled: paramsNotEmpty }
  );

  if (!paramsNotEmpty) {
    return (
      <Typography component="span" variant="inherit">
        {workload || ''}
      </Typography>
    );
  }

  return (
    <Link to={link} component={RouterLink} underline="none" {...linkProps}>
      <LinkBehaviour variant="inherit" fontWeight={500} noWrap>
        {workload}
      </LinkBehaviour>
    </Link>
  );
};
